// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fMWAg","footer":"styles_footer__2UZm-","passCodeTooltip":"styles_passCodeTooltip__2kbU4"};